import React, { useEffect, useState, useContext } from "react";
import "./Warranty.css";

import snowIcon from "../../../../assets/icons/snow.png";
import mudIcon from "../../../../assets/icons/mud.png";
import rockIcon from "../../../../assets/icons/rock.png";
import sandIcon from "../../../../assets/icons/sand.png";
import waterIcon from "../../../../assets/icons/water.png";
import autoIcon from "../../../../assets/icons/auto.png";
import carOutline from "../../../../assets/icons/carOutline.png";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const ICONS = {
  mode_snow: snowIcon,
  mode_mud: mudIcon,
  mode_rock: rockIcon,
  mode_sand: sandIcon,
  mode_water: waterIcon,
  mode_auto: autoIcon,
};

const Warranty = () => {
  const { currentLang } = useContext(LanguageContext);

  const [warranty, setWarranty] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadWarranty = async () => {
      try {
        setLoading(true);
        const response = await getPageContent("mhero1", currentLang);
        setWarranty(response.sections.warranty);
      } catch (e) {
        console.error("Failed to load warranty section", e);
      } finally {
        setLoading(false);
      }
    };

    loadWarranty();
  }, [currentLang]);

  if (loading || !warranty) return null;

  const modes = [
    "mode_snow",
    "mode_mud",
    "mode_rock",
    "mode_sand",
    "mode_water",
    "mode_auto",
  ];

  return (
    <section className="warranty">
      {/* TOP MODES BAND */}
      <div className="warranty-modes">
        <p className="warranty-titlemh1">
          {warranty.title}
        </p>

        <div className="warranty-modes-row">
          {modes.map((key, i) => (
            <React.Fragment key={key}>
              <div className="mode">
                <img src={ICONS[key]} alt={warranty[key]} />
                <span className="itemLabelWarr">
                  {warranty[key]}
                </span>
              </div>
              {i !== modes.length - 1 && <span className="divider" />}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* ARC + CONTENT */}
      <div className="warranty-arc">
        <div className="warranty-content">
          <p className="label">{warranty.warranty_label}</p>
          <h1>
            <p className="big">{warranty.warranty_years}</p>
          </h1>
          <p className="sub">{warranty.warranty_sub}</p>
        </div>

        <img
          className="warranty-carmh1"
          src={carOutline}
          alt="Car outline"
        />
      </div>
    </section>
  );
};

export default Warranty;
